import React from 'react'
import SelectionsDisplayNavItemAccess from './SelectionsDisplayNavItemAccess'
import TranslationCont from '../General/TranslationCont'



export const getFrontpageSelectionHtmlId = (selectionDisplayId, selectionId) => `${selectionDisplayId}_${selectionId}`


const SelectionsDisplayNavAccess = ({
    order,
    items
}) => (
    order ? (
        <nav className="access-page-contents" aria-labelledby="access-page-contents-header">
            <h2 id="access-page-contents-header" className="text-medium access-typo"><TranslationCont id="page_contents">Page Contents</TranslationCont></h2>

            <ul>
                {order.map(id => {
                    const selectionId = items[id].selectionId
                    const htmlId = getFrontpageSelectionHtmlId(id, selectionId)

                    return <SelectionsDisplayNavItemAccess
                        key={`${htmlId}_page_content`}
                        htmlId={htmlId}
                        selectionId={selectionId}
                    />
                })}
            </ul>
        </nav>
    ) : ''
)


export default SelectionsDisplayNavAccess